import { TypedEmitter } from 'tiny-typed-emitter';

enum EventName {
  NAVIGATE_TO = 'navigateTo'
}

interface ExternalControllerEvents {
  navigateTo: (url: string) => void;
}

export class ExternalControllerRaw extends TypedEmitter<ExternalControllerEvents> {
  private static _instance: ExternalControllerRaw;

  constructor() {
    super();
  }

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  public navigateTo(url: string): void {
    this.emit(EventName.NAVIGATE_TO, url);
  }
}

export const ExternalController = ExternalControllerRaw.Instance;
